import { differenceInMinutes, differenceInSeconds, format, isToday, isValid, isYesterday } from "date-fns";

const ABSOLUTE_DATE_FORMAT = "dd MMM, yyyy h:mm a";

/**
 * Converts a date to a user-friendly timestamp.
 *
 * @param {string | Date} date - The date to convert.
 * @returns {string} The user-friendly timestamp.
 */
export const userFriendlyDateTimestamp = (date: string | Date): string => {
  if (!date) {
    return "-";
  }

  const nowDate: Date = new Date();
  const dateValue: Date = new Date(date);

  if (!isValid(dateValue)) {
    return "-";
  }

  // Future dates (e.g. billing period end) — show absolute format
  if (dateValue > nowDate) {
    return format(dateValue, ABSOLUTE_DATE_FORMAT);
  }

  if (differenceInSeconds(nowDate, dateValue) < 60) {
    return "Just Now";
  }

  if (differenceInMinutes(nowDate, dateValue) < 5) {
    return "A few minutes ago";
  }

  if (differenceInMinutes(nowDate, dateValue) < 60) {
    return `${differenceInMinutes(nowDate, dateValue)} minutes ago`;
  }

  if (isToday(dateValue)) {
    return `Today, ${format(dateValue, "h:mm a")}`;
  }

  if (isYesterday(dateValue)) {
    return `Yesterday, ${format(dateValue, "h:mm a")}`;
  }

  return format(dateValue, ABSOLUTE_DATE_FORMAT);
};

export const absoluteDateTimestamp = (date: string | Date): string => {
  if (!date) {
    return "-";
  }

  const dateValue = new Date(date);

  if (!isValid(dateValue)) {
    return "-";
  }

  return format(dateValue, ABSOLUTE_DATE_FORMAT);
};
